import Spinner from '@cohort/shared-frontend/components/Spinner';

export const LoadingScreen: React.FC = () => (
  <div className="w- my-auto flex h-screen w-full items-center justify-center">
    <Spinner size={24} />
  </div>
);
